<template>
  <div class="imgVideoCenter">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="imgVideo" style="position: relative">
        <template #title>
          <span>
            <img src="../../assets/svg/imgVideo.svg" alt="" />
            图片和视频
          </span>
          <span
            class="lineTheme"
            @click.prevent.stop="downloadAllFiles()"
            style="position: absolute; left: 130px"
            >一键下载附件</span
          >
        </template>
        <div class="uploadTips" v-if="!authStatus">
          <fileUploadTips></fileUploadTips>
        </div>
        <div>
          <el-form ref="imgVideoForm" :model="questionFiles" :rules="formRules" label-width="240px">
            <!-- 包装箱拆箱前整体图片/视频 -->
            <el-form-item
              label="包装箱拆箱前整体图片/视频"
              prop="isUnboxOverall"
            >
              <el-radio-group
                v-model="questionFiles.isUnboxOverall"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.unboxOverallList)"
              prop="unboxOverallList"
              v-if="questionFiles.isUnboxOverall == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.unboxOverallList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.unboxOverallList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 包装箱粘贴标签图片 -->
            <el-form-item label="包装箱粘贴标签图片" prop="isBoxLabel">
              <el-radio-group
                v-model="questionFiles.isBoxLabel"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.boxLabelList)"
              prop="boxLabelList"
              v-if="questionFiles.isBoxLabel == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.boxLabelList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.boxLabelList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 包装箱损坏局部图片/视频 -->
            <el-form-item
              label="包装箱损坏局部图片/视频"
              prop="isBoxDamage"
            >
              <el-radio-group
                v-model="questionFiles.isBoxDamage"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.boxDamageList)"
              prop="boxDamageList"
              v-if="questionFiles.isBoxDamage == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.boxDamageList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.boxDamageList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 零部件整体图片 -->
            <el-form-item label="零部件整体图片" prop="isPartOverall">
              <el-radio-group
                v-model="questionFiles.isPartOverall"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.partOverallList)"
              prop="partOverallList"
              v-if="questionFiles.isPartOverall == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.partOverallList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.partOverallList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 零部件局部图片/视频 -->
            <el-form-item label="零部件局部图片/视频" prop="isPartDetail">
              <el-radio-group
                v-model="questionFiles.isPartDetail"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.partDetailList)"
              prop="partDetailList"
              v-if="questionFiles.isPartDetail == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.partDetailList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.partDetailList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 零部件对比图片(错/漏发/状态不对) -->
            <el-form-item
              label="零部件对比图片(错/漏发/状态不对)"
              prop="isPartComparison"
            >
              <el-radio-group
                v-model="questionFiles.isPartComparison"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.partComparisonList)"
              prop="partComparisonList"
              v-if="questionFiles.isPartComparison == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.partComparisonList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.partComparisonList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 供应商信息图片 -->
            <el-form-item label="供应商信息图片" prop="isSupplierInfo">
              <el-radio-group
                v-model="questionFiles.isSupplierInfo"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.supplierInfoList)"
              prop="supplierInfoList"
              v-if="questionFiles.isSupplierInfo == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.supplierInfoList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.supplierInfoList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 其他辅助证据/视频资料 -->
            <el-form-item
              label="其他辅助证据/视频资料"
              prop="isOtherEvidence"
            >
              <el-radio-group
                v-model="questionFiles.isOtherEvidence"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="备注"
              prop="remark"
              v-if="questionFiles.isOtherEvidence == 1"
            >
              <el-input
                v-if="!authStatus"
                v-model="questionFiles.remark"
                :disabled="authStatus"
                placeholder="请输入备注"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div v-else class="problemDesInfo">{{ questionFiles.remark }}</div>
            </el-form-item>
            <el-form-item
              :label="getLabelName(questionFiles.otherEvidenceList)"
              prop="otherEvidenceList"
              v-if="questionFiles.isOtherEvidence == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="questionFiles.otherEvidenceList"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="questionFiles.otherEvidenceList"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=21"
              />
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
export default {
  name: "imgVideo",
  components: { fileUploadTips },
  data() {
    return {
      activeNames: ["imgVideo"], // 全部展开
      action: "/customer/quality/upload",
      form: {
        faultVideo: 1,
        faultVideoFiles: [],
        faultCode: 1,
        faultCodeRemark: "",
        faultCodeFiles: [],
        otherInstructions: 1,
        otherRemark: "",
        otherFiles: [],
      },
      questionFiles: {},
      allFileList: [],
      // rules: {
      //   faultVideo: [{required: true, message: " "}],
      //   faultVideoFiles: [{required: true, message: " "}],
      //   faultCode: [{required: true, message: " "}],
      //   faultCodeRemark: [{required: true, message: " "}],
      //   otherInstructions: [{required: true, message: " "}],
      //   otherRemark: [{required: true, message: " "}],
      // }
    };
  },
  props: {
    resourceInfo: {
      type: [Array, Object],
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    formRules() {
      const isRequired = !this.authStatus;
      // 公共规则配置
      const commonRule = {
        required: isRequired,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        isUnboxOverall: createRule("包装箱拆箱前整体图片/视频"),
        unboxOverallList: createRule("包装箱拆箱前整体图片/视频附件"),
        isBoxLabel:createRule("包装箱粘贴标签图片"),
        boxLabelList:createRule("包装箱粘贴标签图片附件"),
        isBoxDamage: createRule("包装箱损坏局部图片/视频"),
        boxDamageList: createRule("包装箱损坏局部图片/视频附件"),
        isPartOverall:createRule("零部件整体图片"),
        partOverallList: createRule("零部件整体图片附件"),
        isPartDetail: createRule("故障视频/图片"),
        partDetailList:createRule("有故障视频/图片附件"),
        isPartComparison: createRule("零部件对比图片(错/漏发/状态不对)"),
        partComparisonList: createRule("零部件对比图片(错/漏发/状态不对)附件"),
        isSupplierInfo:createRule("供应商信息图片"),
        supplierInfoList: createRule("供应商信息图片附件"),
        isOtherEvidence: createRule("其他辅助证据/视频资料"),
        remark:createRule("其他辅助证据/视频资料备注"),
        otherEvidenceList:createRule("其他辅助证据/视频资料附件"),
      };
    },
  },
  async created() {
    this.getResourceInfo();
  },
  methods: {
    // 获取数据
    getResourceInfo() {
      if (this.resourceInfo) {
        this.form = this.resourceInfo;
        this.questionFiles = this.resourceInfo.questionDescriptionAndFiles;
        this.allFileList =[
          ...this.questionFiles.unboxOverallList,
          ...this.questionFiles.boxLabelList,
          ...this.questionFiles.boxDamageList,
          ...this.questionFiles.partOverallList,
          ...this.questionFiles.partDetailList,
          ...this.questionFiles.partComparisonList,
          ...this.questionFiles.supplierInfoList,
          ...this.questionFiles.otherEvidenceList
        ]
      }
    },
    // 附件标题是否显示
    getLabelName(file) {
      if (this.authStatus) {
        if (file.length > 0) {
          return "附件";
        } else {
          return "";
        }
      } else {
        return "附件";
      }
    },
    validateForm() {
      return this.$refs["imgVideoForm"].validate()
        .then(() => ({ isValid: true, object: null }))
        .catch(errors => ({ isValid: false, object: errors }));
    },
    // 一键下载附件
    async downloadAllFiles() {
      try {
        const files = this.allFileList || [];

        if (files.length === 0) {
          this.$DonMessage.warning("暂无附件");
          return;
        }

        const zip = new JSZip();
        const fileCountMap = {}; // 用于记录同名文件出现次数

        await Promise.all(
          files.map(async (item, index) => {
            try {
              const url = item.url || item.filePath;
              if (!url) return;

              const response = await fetch(url);
              if (!response.ok) throw new Error(`下载失败：${url}`);

              const blob = await response.blob();
              let fileName = item.fileName || item.name || `附件_${index + 1}`;

              // 处理同名文件
              if (zip.files[fileName]) {
                fileCountMap[fileName] = (fileCountMap[fileName] || 0) + 1;
                const ext = fileName.split(".").pop();
                const baseName = fileName.replace(/\.[^/.]+$/, "");
                fileName = `${baseName}_${fileCountMap[fileName]}.${ext}`;
              }
              zip.file(fileName, blob);
            } catch (error) {
              console.error(`文件下载失败: ${error.message}`);
              throw error;
            }
          })
        );

        const zipBlob = await zip.generateAsync({
          type: "blob",
          compression: "DEFLATE",
        });

        saveAs(zipBlob, `图片和视频附件_${new Date().getTime()}.zip`);
        this.$DonMessage.success("下载完成");
      } catch (error) {
        console.error("打包下载失败:", error);
        this.$DonMessage.error(`下载失败: ${error.message}`);
      }
    },
  },
};
</script>
